var map = {
	"./cnn-money-x2.png": 2035,
	"./cnn-money.png": 2239,
	"./economist-x2.png": 2036,
	"./economist.png": 2240,
	"./mashable-x2.png": 2037,
	"./mashable.png": 2241,
	"./tech-crunch-x2.png": 2038,
	"./tech-crunch.png": 2242,
	"./thenewyorker-x2.png": 2039,
	"./thenewyorker.png": 2243,
	"./thrillist-x2.png": 2040,
	"./thrillist.png": 2244,
	"./time-x2.png": 2041,
	"./time.png": 2245,
	"./usa-today-x2.png": 2042,
	"./usa-today.png": 2246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2238;